import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { enableMapSet } from 'immer';

import { environment } from '@coin/shared/core/util-environments';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';

// Immer resolves its Map/Set support lazily from inside a proxy get trap, so the plugin
// must be registered before the first `produce` that drafts a Map or Set (GMTEC-24514).
enableMapSet();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, APP_CONFIG).catch(err => console.log(err));
